import { gql } from 'urql';

const BillManagerHowToQualifyScreenQuery = gql`
  query BillManagerHowToQualifyScreen {
    billManagerHowToQualifyScreen {
      __typename
      id
      headlineText
      subtitleText
      sectionHeaderText
      featureItems {
        id
        icon
        text
      }
      finePrintText
      primaryButtonText
    }
  }
`;

export default BillManagerHowToQualifyScreenQuery;
